<template>
  <div class="inner-box">
    <form @submit.prevent="saveButton" style="display: grid;">
      <div class="content-name">
        <h2 class="dp-ib">대행료관리</h2>
        <el-form size="small" style="float: right;">
          <el-button type="primary" icon="el-icon-document-add" @click="saveButton">저장</el-button>
          <el-button type="info" icon="el-icon-close" @click="cancel">취소</el-button>
          <el-button type="danger" icon="el-icon-delete" @click="deleteRow">삭제</el-button>
        </el-form>
      </div>
    </form>
    <!-- 테이블 -->
    <div class="table-area"  style="width: 100%;">
      <div class="table-b">
        <div class="table-header">
          <div class="grid-tbl-box">
            <ag-grid-vue
                ref="gridSub"
                style="width: 100%; height: 45vh; min-height: 25px;"
                class="ag-theme-alpine"
                :enableRangeSelection="true"
                :columnDefs="columnDefsSub"
                :defaultColDef="defaultColDefSub"
                :frameworkComponents="frameworkComponents"
                :rowData="subData"
                :gridOptions="gridOptionsSub"
                :suppressRowClickSelection="false"
                :statusBar="statusBar"
                @grid-ready="onReadyMain"
                @cell-clicked="onCellClickedMain"
            />
          </div>
        </div>
      </div>
      <AsChargeInfo ref="AsChargeInfo"  :groupDetail="groupDetail" :parentNm="parentNm" style="height: 100%"/>

    </div> <!-- table sub contain -->
  </div>
</template>
<script>
import _ from "lodash";

import CheckboxCellRenderer from '@/components/agGrid/checkbox-cell-renderer'
import common from '@/mixin/common';
import AsChargeInfo from '@/components/InfoManage/AsChargeInfo.vue';

/**
 * Url JOIN
 */
function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}

export default {
  mixins: [common],
  name: "group",
  components: {AsChargeInfo},
  data() {
    return {
      title: "",
      deleteid: "",
      deleteList: [],
      parentNm: "",
      form: {
        companyId: "",
        createDt: "",
        creatorId: "",
        creatorNm: "",
        endDt: "",
        squareFee1: 0,
        squareFee2: 0,
        squareFee3: 0,
        squareFee4: 0,
        squareFee5: 0,
        squareFee6: 0,
        squareFee7: 0,
        squareFee8: 0,
        squareFee9: 0,
        squareFee10: 0,
        squareFee11: 0,
        squareFee12: 0,
        squareFee13: 0,
        squareFee14: 0,
        squareFee15: 0,
        squareFee16: 0,
        squareFee17: 0,
        squareFee18: 0,
        squareFee19: 0,
        squareFee20: 0,
        squareFee21: 0,
        squareFee22: 0,
        squareFee23: 0,
        squareFee24: 0,
        squareFee25: 0,
        squareFee26: 0,
        squareFee27: 0,
        squareFee28: 0,
        squareFee29: 0,
        squareFee30: 0,
        squareFeeId: "",
        squareFeeType: "",
        startDt: this.$moment().format('YYYY-MM-DD'),
        updateDt: "",
        updatorId: "",
        updatorNm: ""
      },
      defForm: {
        companyId: "",
        createDt: "",
        creatorId: "",
        creatorNm: "",
        endDt: "",
        squareFee1: "",
        squareFee2: "",
        squareFee3: "",
        squareFee4: "",
        squareFee5: "",
        squareFee6: "",
        squareFee7: "",
        squareFee8: 0,
        squareFee9: 0,
        squareFee10: 0,
        squareFee11: "",
        squareFee12: "",
        squareFee13: "",
        squareFee14: "",
        squareFee15: "",
        squareFee16: 0,
        squareFee17: 0,
        squareFee18: 0,
        squareFee19: 0,
        squareFee20: 0,
        squareFee21: "",
        squareFee22: "",
        squareFee23: "",
        squareFee24: "",
        squareFee25: "",
        squareFee26: "",
        squareFee27: 0,
        squareFee28: 0,
        squareFee29: 0,
        squareFee30: 0,
        squareFeeId: "",
        squareFeeType: "",
        startDt: this.$moment().format('YYYY-MM-DD'),
        updateDt: "",
        updatorId: "",
        updatorNm: ""
      },
      data: [],
      subData: [],
      gridOptions: {
        //enableColResize: true,
        //enableFilter: true,
        //animateRows: false,
        //enableSorting: true
        rowModelType: 'serverSide',
      },
      gridOptionsSub: {
        //enableColResize: true,
        //enableFilter: true,
        //animateRows: false,
        //enableSorting: true
      },
      defaultColDef: {
        resizable: true,
        filter: true,
        sortable: true,
        editable: true,
        width: 240,
        flex: 1,
      },
      defaultColDefSub: {
        resizable: true,
        filter: true,
        sortable: true,
        editable: true,
        width: 240,
        flex: 1,
        //cellStyle : {'justify-content': 'center','align-items': 'center', 'display': 'flex','height': '100%'}
      },
      groupDetail: [],
      gridApi: null,
      columnApi: null,
      columnDefs: [],
      gridApiSub: null,
      columnApiSub: null,
      columnDefsSub: [],
      frameworkComponents: null,
      autoGroupColumnDef: null,
      rowModelType: null,
      isServerSideGroupOpenByDefault: null,
      isServerSideGroup: null,
      getServerSideGroupKey: null,
      selectId : "",
    };
  },
  methods: {
    //메인그리드 Ready
    onReadyMain(params) {
      //메인그리드 api 정의
      this.gridApi = params.api;
      this.columnApi = params.columnApi;
      this.gridApi.sizeColumnsToFit();
      this.autoSizeAll(this.columnApi)

      this.$store.commit('loading')
      this.$http
          .post("/api/asChargeMng/list", {
            companyId: this.$store.state.loginInfo.compCd,
            squareFeeType: "AS",
            processTime: ""
          })
          .then(response => {
            this.subData = response.data
          }).finally(() => {
        this.$store.commit('finish')
      });
    },
    //서브그리드 Ready
    onReadySub(params) {
      //서브그리드 api 정의
      this.gridApiSub = this.gridOptionsSub.api;
      this.columnApiSub = this.gridOptionsSub.columnApi;
      this.gridApiSub.sizeColumnsToFit();
    },
    autoSizeAll(columnApi) {
      const allColumnIds = [];
      columnApi.columnController.gridColumns.forEach((column) => {
        allColumnIds.push(column.getId());
      });
      columnApi.columnController.autoSizeColumns(allColumnIds, false);
    },
    //그리드컬럼 정의
    createColumnDefs() {
      const vm = this

      this.autoGroupColumnDef = {
        field: 'menu_nm',
        cellRendererParams: {
          innerRenderer: (params) => {
            return params.data.menu_nm;
          },
        },
      };
      this.rowModelType = 'serverSide';
      this.isServerSideGroupOpenByDefault = (params) => {
        // open first two levels by default
        return params.rowNode.level < 1;
      };
      this.isServerSideGroup = (dataItem) => {
        // indigroupe if node is a group
        //console.log(dataItem);
        return dataItem.group;
      };
      this.getServerSideGroupKey = (dataItem) => {
        // specify which group key to use
        return dataItem.menu_id;
      };

      this.columnDefsSub = [
        {
          headerName: '적용일자', field: 'startDt', width: 300, editable: false, valueFormatter: (params) => {
            return vm.getDateFormat(`${params.value}`);
          }
        },
        {headerName: '기본대행료', field: 'squareFee7', width: 200, editable: false},
        {
          headerName: 'AS', children: [
            {headerName: '즉시', field: 'squareFee1', width: 200, editable: false},
            {headerName: '당일', field: 'squareFee2', width: 200, editable: false},
            {headerName: '익일', field: 'squareFee3', width: 200, editable: false},
            {headerName: '기본', field: 'squareFee4', width: 200, editable: false},
            {headerName: '추가', field: 'squareFee5', width: 200, editable: false},
            {headerName: '추가건수', field: 'squareFee6', width: 200, editable: false},
          ], width: 400, editable: false
        },
        {
          headerName: '출장비', children: [
            {headerName: '기존', field: 'squareFee11', width: 200, editable: false},
            {headerName: '1급지', field: 'squareFee12', width: 200, editable: false},
            {headerName: '2급지', field: 'squareFee13', width: 200, editable: false},
            {headerName: '3급지', field: 'squareFee14', width: 200, editable: false},
            {headerName: '4급지', field: 'squareFee15', width: 200, editable: false},
          ], width: 400, editable: false
        },
        {
          headerName: '설치비', children: [
            {headerName: 'Set', field: 'squareFee21', width: 200, editable: false},
            {headerName: '단독', field: 'squareFee22', width: 200, editable: false},
            {headerName: '추가Set', field: 'squareFee23', width: 200, editable: false},
            {headerName: '추가단독', field: 'squareFee24', width: 200, editable: false},
            {headerName: '추가', field: 'squareFee25', width: 200, editable: false},
            {headerName: '추가건수', field: 'squareFee26', width: 200, editable: false},
          ], width: 400, editable: false
        }
      ]
    },
    //Main 그리드 SelctionChange 발생
    onCellClickedMain(params) {
      const voRow = params.data //선택된 Row
      // this.groupDetail = _.clone(this.defForm);
      // this.parentNm = voRow[0].menu_nm;

      this.$store.commit('loading')
      this.$http
          .post("/api/asChargeMng/detail", {
            companyId: this.$store.state.loginInfo.compCd,
            squareFeeType: "AS",
            squareFeeId: voRow.squareFeeId,
            processTime: ""
          })
          .then(response => {
            this.groupDetail = response.data[0];
            this.selectId = voRow.squareFeeId;
          }).finally(() => {
        this.$store.commit('finish')
      });

    },
    getDateFormat(val) {
      if (val) {
        return this.$moment(val).format('YYYY-MM-DD')
      }
    },
    goOpen() {

      this.$store.commit('loading')
      this.$http
          .post("/api/asChargeMng/list", {
            companyId: this.$store.state.loginInfo.compCd,
            squareFeeType: "AS",
            processTime: ""
          })
          .then(response => {
            this.subData = response.data
          }).finally(() => {
        this.$store.commit('finish')
      });

    },
    checkVal(){
      const val = JSON.parse(JSON.stringify(this.$refs.AsChargeInfo.form));

      if(val.squareFee1 == ""){
        this.$swal({ type: 'warning', text: val.squareFeeId === 17 ?'즉시처리를 입력해주세요.' : '접수일처리를 입력해주세요.' })
        return false;
      }


      if(val.squareFee2 == ""){
        this.$swal({ type: 'warning', text: '당일처리를 입력해주세요.' })
        return false;
      }


      if(val.squareFee3 == ""){
        this.$swal({ type: 'warning', text: val.squareFeeId === 17 ?'익일처리를 입력해주세요.' : 'D+2처리를 입력해주세요.' })
        return false;
      }


      if(val.squareFee4 == ""){
        this.$swal({ type: 'warning', text: '기본처리를 입력해주세요.' })
        return false;
      }


      if(val.squareFee5 == ""){
        this.$swal({ type: 'warning', text: '추가처리를 입력해주세요.' })
        return false;
      }


      if(val.squareFee6 == ""){
        this.$swal({ type: 'warning', text: '추가건수를 입력해주세요.' })
        return false;
      }


      if(val.squareFee11 == ""){
        this.$swal({ type: 'warning', text: '기본출장비를 입력해주세요.' })
        return false;
      }


      if(val.squareFee12 == ""){
        this.$swal({ type: 'warning', text: '장거리(1급지)를 입력해주세요.' })
        return false;
      }


      if(val.squareFee13 == ""){
        this.$swal({ type: 'warning', text: '장거리(2급지)를 입력해주세요.' })
        return false;
      }


      if(val.squareFee13 == ""){
        this.$swal({ type: 'warning', text: '장거리(3급지)를 입력해주세요.' })
        return false;
      }


      if(val.squareFee14 == ""){
        this.$swal({ type: 'warning', text: '장거리(4급지)를 입력해주세요.' })
        return false;
      }


      if(val.squareFee7 == ""){
        this.$swal({ type: 'warning', text: '기본대행료를 입력해주세요.' })
        return false;
      }


      if(val.squareFee21 == ""){
        this.$swal({ type: 'warning', text: 'Set설치를 입력해주세요.' })
        return false;
      }


      if(val.squareFee22 == ""){
        this.$swal({ type: 'warning', text: '단독설치를 입력해주세요.' })
        return false;
      }


      if(val.squareFee23 == ""){
        this.$swal({ type: 'warning', text: '추가Set설치를 입력해주세요.' })
        return false;
      }


      if(val.squareFee24 == ""){
        this.$swal({ type: 'warning', text: '추가단독설치를 입력해주세요.' })
        return false;
      }


      if(val.squareFee25 == ""){
        this.$swal({ type: 'warning', text: '추가설치를 입력해주세요.' })
        return false;
      }

      if(val.squareFee26 == ""){
        this.$swal({ type: 'warning', text: '설치추가건수를 입력해주세요.' })
        return false;
      }

      return true;

    },
    saveButton(){
      if(this.checkVal()) this.save();
    },
    save() {
      const AsChargeInfo = JSON.parse(JSON.stringify(this.$refs.AsChargeInfo.form));

      // 비어있다면 생성 , 비어있지 않다면 수정
      if(AsChargeInfo.squareFeeId == ""){

        this.$http
            .put('/api/asChargeMng/save',{
              companyId: this.$store.state.loginInfo.compCd,
              squareFeeType : "AS",
              squareFeeId : 0,
              startDt : AsChargeInfo.startDt,
              squareFee1: AsChargeInfo.squareFee1,
              squareFee2: AsChargeInfo.squareFee2,
              squareFee3: AsChargeInfo.squareFee3,
              squareFee4: AsChargeInfo.squareFee4,
              squareFee5: AsChargeInfo.squareFee5,
              squareFee6: AsChargeInfo.squareFee6,
              squareFee7: AsChargeInfo.squareFee7,
              squareFee8: AsChargeInfo.squareFee8,
              squareFee9: AsChargeInfo.squareFee9,
              squareFee10: AsChargeInfo.squareFee10,
              squareFee11: AsChargeInfo.squareFee11,
              squareFee12: AsChargeInfo.squareFee12,
              squareFee13: AsChargeInfo.squareFee13,
              squareFee14: AsChargeInfo.squareFee14,
              squareFee15: AsChargeInfo.squareFee15,
              squareFee16: AsChargeInfo.squareFee16,
              squareFee17: AsChargeInfo.squareFee17,
              squareFee18: AsChargeInfo.squareFee18,
              squareFee19: AsChargeInfo.squareFee19,
              squareFee20: AsChargeInfo.squareFee20,
              squareFee21: AsChargeInfo.squareFee21,
              squareFee22: AsChargeInfo.squareFee22,
              squareFee23: AsChargeInfo.squareFee23,
              squareFee24: AsChargeInfo.squareFee24,
              squareFee25: AsChargeInfo.squareFee25,
              squareFee26: AsChargeInfo.squareFee26,
              squareFee27: AsChargeInfo.squareFee27,
              squareFee28: AsChargeInfo.squareFee28,
              squareFee29: AsChargeInfo.squareFee29,
              squareFee30: AsChargeInfo.squareFee30,
              creatorId: this.$store.state.loginInfo.id,
              processTime: "",
            })
            .then(response => {
              this.$swal({ type: 'success', text: '저장되었습니다.' });
              this.goOpen();
            })
            .catch(({ message }) => {
              if (message === "Request failed with status code 500") {
                this.$swal({ type: "error", text: "오류가 발생했습니다." });
              }
            });
      }else{
        //수정 시작

        this.$http
            .put('/api/asChargeMng/update',{
              companyId: this.$store.state.loginInfo.compCd,
              squareFeeType : AsChargeInfo.squareFeeType,
              squareFeeId : AsChargeInfo.squareFeeId,
              startDt : AsChargeInfo.startDt,
              squareFee1: AsChargeInfo.squareFee1,
              squareFee2: AsChargeInfo.squareFee2,
              squareFee3: AsChargeInfo.squareFee3,
              squareFee4: AsChargeInfo.squareFee4,
              squareFee5: AsChargeInfo.squareFee5,
              squareFee6: AsChargeInfo.squareFee6,
              squareFee7: AsChargeInfo.squareFee7,
              squareFee8: AsChargeInfo.squareFee8,
              squareFee9: AsChargeInfo.squareFee9,
              squareFee10: AsChargeInfo.squareFee10,
              squareFee11: AsChargeInfo.squareFee11,
              squareFee12: AsChargeInfo.squareFee12,
              squareFee13: AsChargeInfo.squareFee13,
              squareFee14: AsChargeInfo.squareFee14,
              squareFee15: AsChargeInfo.squareFee15,
              squareFee16: AsChargeInfo.squareFee16,
              squareFee17: AsChargeInfo.squareFee17,
              squareFee18: AsChargeInfo.squareFee18,
              squareFee19: AsChargeInfo.squareFee19,
              squareFee20: AsChargeInfo.squareFee20,
              squareFee21: AsChargeInfo.squareFee21,
              squareFee22: AsChargeInfo.squareFee22,
              squareFee23: AsChargeInfo.squareFee23,
              squareFee24: AsChargeInfo.squareFee24,
              squareFee25: AsChargeInfo.squareFee25,
              squareFee26: AsChargeInfo.squareFee26,
              squareFee27: AsChargeInfo.squareFee27,
              squareFee28: AsChargeInfo.squareFee28,
              squareFee29: AsChargeInfo.squareFee29,
              squareFee30: AsChargeInfo.squareFee30,
              updatorId: this.$store.state.loginInfo.id,
              processTime: "",
            })
            .then(response => {
              this.$swal({ type: 'success', text: '수정되었습니다.' });
              this.goOpen();
            })
            .catch(({ message }) => {
              if (message === "Request failed with status code 500") {
                this.$swal({ type: "error", text: "오류가 발생했습니다." });
              }
            });
      }



    },
    deleteRow() {

      try{

        let squareFeeId =  parseInt(this.selectId);
        let compCd =  this.$store.state.loginInfo.compCd;


        this.$http.delete(_url("/api/asChargeMng/delete/"+ (compCd) +"/AS/" + (squareFeeId) ), {
          process_time : ""
        }).then(response => {
          this.$swal({ type: 'success', text: '삭제 되었습니다.' });
          this.goOpen();
        });

      }catch (e) {
        this.$swal({
          type: 'warning',
          text: e
        })
      }
    // },

    },
    cancel(){
      // groupInfo 초기화
      this.$refs.AsChargeInfo.form = _.clone(this.defForm);
      this.selectId = "";
    },
    createFakeServer(ServerData) {
      const Server = {
        data: ServerData,
        getData: function (request) {
          function extractRowsFromData(groupKeys, data) {
            if (groupKeys.length === 0) {
              return data.map(function (d) {
                var has_inner_menu = d.inner_menu.length == 0? false : true;
                return {
                  group:  has_inner_menu,
                  menu_id: d.menu_id,
                  menu_nm: d.menu_nm,
                };
              });
            }
            var key = groupKeys[0];
            for (var i = 0; i < data.length; i++) {
              if (data[i].menu_id === key) {
                return extractRowsFromData(
                    groupKeys.slice(1),
                    data[i].inner_menu.slice()
                );
              }
            }
          }
          return extractRowsFromData(request.groupKeys, this.data);
        },
      };
      return Server;
    },
    createServerSideDatasource(fakeServer) {
      const dataSource = {
        getRows: (params) => {
          //console.log('ServerSideDatasource.getRows: params = ', params);

          var allRows = fakeServer.getData(params.request);
          var request = params.request;
          var doingInfinite = request.startRow != null && request.endRow != null;
          var result = doingInfinite
              ? {
                rowData: allRows.slice(request.startRow, request.endRow),
                rowCount: allRows.length,
              }
              : { rowData: allRows };
          setTimeout(function () {
            params.success(result);
          }, 200);
        },
      };
      return dataSource;
    }
  },
  beforeMount() {

    this.createColumnDefs(); //그리드 컬럼정의 함수 호출

    this.frameworkComponents = {//그르드에서 사용할 외부 comp 등록
      checkboxRenderer: CheckboxCellRenderer,
    };

  },
  mounted() {
    //this.goOpen();
  },
  created() {
    this.statusBar = {
      statusPanels: [
        { statusPanel: 'agTotalRowCountComponent', align: 'right' },
      ],
    };
  },
};

</script>